<!--耗金额统计-->
<template>
  <div  class="app-container">
    <!--    查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="queryParam.searchDay"
              type="daterange"
              range-separator=""
              start-placeholder="开始"
              value-format="yyyy-MM-dd"
              end-placeholder="结束">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
      </div>
    </div>
    <el-card class="table-container" style="margin-top: 0px;">
      <div class="op-con">
        <el-radio-group  v-model="radio" @change="onChangeDay">
          <el-radio :label="0">{{redioDayRange[0].dayDes}}</el-radio>
          <el-radio :label="1">{{redioDayRange[1].dayDes}}</el-radio>
          <el-radio :label="2">{{redioDayRange[2].dayDes}}</el-radio>
          <el-radio :label="3">{{redioDayRange[3].dayDes}}</el-radio>
          <el-radio :label="4">{{redioDayRange[4].dayDes}}</el-radio>
          <el-radio :label="5">{{redioDayRange[5].dayDes}}</el-radio>
          <el-radio :label="6">{{redioDayRange[6].dayDes}}</el-radio>
        </el-radio-group>
        <span class="op-title">(点击立即查询)</span>
      </div>
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="520"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="cardName" label="卡类型"></el-table-column>
        <el-table-column prop="totalPay" label="金额" ></el-table-column>
      </el-table>
    </el-card>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
  .op-con{
    width: 90%;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fcf4e9;
    border-radius: 8px;
    margin-left: 5%;
  }
  .op-title{
    font-size: 14px;
    font-weight: 500;
    line-height: 45px;
    text-align: center;
    color: #0d6fb8;
    margin-left: 30px;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import {addReason, delReason, selectall} from "../../../api/cancelBookReason";
  import commonUtils from "../../../utils/commonUtils";
  import messageUtils from "../../../utils/messageUtils";
  import {selectConsumeMoneyData} from "../../../api/bas/basConsumeData";
  import timeUtils from "../../../utils/timeUtils";
  import {formatDate} from "../../../utils/date";
  import enumsUtil, {EChildGender, EUserExpStatu} from "../../../utils/enumsUtil";
  import {getStoreCardPerformance, queryPageStatisticsDetail} from "../../../api/mkt/MktStatistics";

  export default {
    data() {
      return {
        tableData:[],

        queryParam :{
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          searchDay :[],
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        radio: 0,
        redioDayRange:[
          {id: 0, day:[], dayDes:'本周'},
          {id: 1, day:[], dayDes:'本月'},
          {id: 2, day:[], dayDes:'近30天'},
          {id: 3, day:[], dayDes:'近60天'},
          {id: 4, day:[], dayDes:'近半年'},
          {id: 5, day:[], dayDes:'上半年'},
          {id: 6, day:[], dayDes:'下半年'},
          {id: 7, day:[], dayDes:'今年'},
        ],
        redioDay:null,

      }
    },
    created() {
      let now = new Date();
      let monday = timeUtils.getFirstDayOfWeek(now); //周一
      this.queryParam.searchDay = [];
      this.queryParam.searchDay.push(formatDate(monday,"yyyy-MM-dd"));
      this.queryParam.searchDay.push(formatDate(monday,"yyyy-MM-dd"));
      this.initRedioDayRange();
      globaldata.getStoreLessonCard(this.getStoreLessonCard)

    },
    methods: {
      handleSizeChange(val) {
        this.queryParam.pageNum = 1;
        this.queryParam.pageSize = val;
        this.fitchData();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchData();
      },

      initRedioDayRange(){
        this.redioDayRange = [];
        let now = new Date();
        let monday = timeUtils.getFirstDayOfWeek(now); //周一
        let rangeItem = {
          day:[formatDate(monday,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"本周"
        }
        this.redioDayRange.push(rangeItem);

        let fm = timeUtils.getFirstDayOfMonth(now); //
        let rangeItemFn = {
          day:[formatDate(fm,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"本月"
        }
        this.redioDayRange.push(rangeItemFn);

        let bf30 = timeUtils.getBeforeDayOfDate(now,30);
        let rangeItembf30 = {
          day:[formatDate(bf30,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"近30天"
        }
        this.redioDayRange.push(rangeItembf30);

        let bf60 = timeUtils.getBeforeDayOfDate(now,60);
        let rangeItembf60 = {
          day:[formatDate(bf60,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"近60天"
        }
        this.redioDayRange.push(rangeItembf60);



        let bhe = timeUtils.getFirstDayOfHYear(now);
        let rangeItembfHBY = {
          day:[formatDate(bhe[0],"yyyy-MM-dd"),formatDate(bhe[1],"yyyy-MM-dd")],
          dayDes:"上半年"
        }
        this.redioDayRange.push(rangeItembfHBY);

        let ahe = timeUtils.getFirstDayOfLYear(now);

        let rangeItembfABY = {
          day:[formatDate(ahe[0],"yyyy-MM-dd"),formatDate(ahe[1],"yyyy-MM-dd")],
          dayDes:"下半年"
        }

        this.redioDayRange.push(rangeItembfABY);

        let rangeItembfAlly = {
          day:[formatDate(bhe[0],"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"全年"
        }
        this.redioDayRange.push(rangeItembfAlly);


      },

      //点击查询按钮
      onBtnSearch(){
        this.fitchData();
      },
      fitchData(){
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdCF(),
          startDay:this.queryParam.searchDay[0],
          endDay :this.queryParam.searchDay[1],

        }
        const loading = this.myLoading();

        getStoreCardPerformance(param).then(response =>
        {
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.refreshData(data);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        this.tableData = list;
        let total = 0.0;
        for (let iC =0;iC<this.tableData.length;++iC){
          let card =  this.tableData[iC];
          for (let i = 0;i<this.storeLessonCards.length;++i){
            let storeLessonCard = this.storeLessonCards[i];
              if (card.storeLessonCardId == storeLessonCard.id){
                card.cardName = storeLessonCard.name;
                total+=card.totalPay;
                break;
              }
          }
        }

        let totalCount = {
          cardName:"总计",
          totalPay:total,
        }
        this.tableData.push(totalCount)


      },
//获取店铺所有VIP卡
      getStoreLessonCard(data){
        this.storeLessonCards = data;
        this.fitchData();
      },
      onChangeDay(val){
        let day = this.redioDayRange[val].day;
        this.queryParam.searchDay = [];
        this.queryParam.searchDay.push(day[0]);
        this.queryParam.searchDay.push(day[1]);
        this.fitchData();
      },



    }
  }
</script>






// WEBPACK FOOTER //
// src/views/marketing-manager/mkt-store-performance-statistics/index.vue